import { useEffect, useCallback } from 'react';
import { useStore, State } from 'store';

import fetchRunFiles from 'store/fetchRunFiles';
import getCurrentProjectState from 'store/getCurrentProjectState';

import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunFile from 'types/IRunFile';

const initAsync: IAsync<IPaginatedResponse<IRunFile>> = { status: 'INIT' };

export default function useAutofetchedRunFilesAsync(
  runId: string,
  { page, pageSize, search }: { page?: number; pageSize?: number; search?: string } = {},
): IAsync<IPaginatedResponse<IRunFile>> {
  const runFilesAsync = useStore(
    useCallback((state: State) => getCurrentProjectState(state).runFilesAsyncMap[runId], [runId]),
  );

  useEffect(() => {
    fetchRunFiles(runId, { page, pageSize, search });
  }, [runId, page, pageSize, search]);

  return runFilesAsync || initAsync;
}
